export interface IFaqItemData {
  readonly id?: number
  question?: string
  answer?: string
}

export interface IFaqItem extends IFaqItemData {
  readonly id: number
  validate(): boolean
  update(data?: IFaqItemData): void
}

export const FAQ_QUESTION_MAX_LENGTH = 1000;
export const FAQ_ANSWER_MAX_LENGTH = 1000;
